import { createElement } from 'react';
import { Space } from '@formily/antd';
import { createVoidSchemaComponent, useCurrentNode } from '../../shared';
const PreviewSpace = (props) => {
    const node = useCurrentNode(props);
    if (node.children.size === 0) {
        return createElement("div", Object.assign({}, props), props.children);
    }
    else {
        return createElement(Space, Object.assign({}, props));
    }
};
const AdvancedSpace = (props) => {
    if (props.__designMode === 'design') {
        return createElement(PreviewSpace, Object.assign({}, props));
    }
    return createElement(Space, Object.assign({}, props));
};
const FormilySpace = createVoidSchemaComponent({
    componentName: 'Space',
    component: AdvancedSpace,
});
export default FormilySpace;
